module.exports = __webpack_public_path__ + "258a1c043d3cd4e7d157078b6358113e.svg";